import { AuthProvider } from "contexts/JWTAuthContext";
import SettingsProvider from "contexts/SettingsContext";
import TitleContextProvider from "contexts/TitleContext";
import "nprogress/nprogress.css";
import { StrictMode } from "react";
import React from "react";
import ReactDOM from "react-dom";
import "react-image-lightbox/style.css";
import { BrowserRouter } from "react-router-dom";
import "simplebar/dist/simplebar.min.css";
import App from "./App";

import { Provider } from "react-redux";
import { store } from "./redux/store";

import "./__fakeApi__";

// Fix for react-apexcharts: Make React, ApexCharts, and PropTypes available globally
import ApexCharts from "apexcharts";
import PropTypes from "prop-types";
(window as any).React = React;
(window as any).ApexCharts = ApexCharts;
(window as any).PropTypes = PropTypes;

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <SettingsProvider>
          <TitleContextProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </TitleContextProvider>
        </SettingsProvider>
      </AuthProvider>
    </Provider>
  </StrictMode>,
  document.getElementById("root")
);
